import React from 'react';

const ProductRatingInlineContainer = ({ componentId }: any) => {
	return (
		<div
			data-selection={componentId}
			className="inlineContainer vtex-reviews-and-ratings-3-x-inlineContainer review-summary mw8 center"
		>
			<span className="t-heading-5 v-mid">
				<span className="stars vtex-reviews-and-ratings-3-x-stars c-action-primary">
					<span className="star star--filled vtex-reviews-and-ratings-3-x-star vtex-reviews-and-ratings-3-x-star--filled">
						★
					</span>
					<span className="star star--filled vtex-reviews-and-ratings-3-x-star vtex-reviews-and-ratings-3-x-star--filled">
						★
					</span>
					<span className="star star--filled vtex-reviews-and-ratings-3-x-star vtex-reviews-and-ratings-3-x-star--filled">
						★
					</span>
					<span className="star star--empty vtex-reviews-and-ratings-3-x-star vtex-reviews-and-ratings-3-x-star--empty">
						☆
					</span>
					<span className="star star--empty vtex-reviews-and-ratings-3-x-star vtex-reviews-and-ratings-3-x-star--empty">
						☆
					</span>
				</span>
			</span>{' '}
			<span className="summaryTotalReviews vtex-reviews-and-ratings-3-x-summaryTotalReviews review__rating--count dib v-mid">
				(59)
			</span>
		</div>
	);
};

export default ProductRatingInlineContainer;
